import { finishEntriConnectConfiguration } from '../api';
import { DNS_SHOULD_NOT_EXIST, DNS_UNKNOWN } from '../constants/domainConstants';
import { DOMAIN_DATA } from '../constants/queryData';

export const filterDNSRecords = (dnsRecords) =>
  dnsRecords.filter(
    ({ expectedValue }) => expectedValue !== DNS_SHOULD_NOT_EXIST && expectedValue !== DNS_UNKNOWN
  );

export const saveEntriConnectEvent = async ({ userId, domainId, dnsRecords, queryClient }) => {
  try {
    const configureDNSEvent = await finishEntriConnectConfiguration({
      userId,
      domainId,
      // only keep certain properties
      dnsRecords: dnsRecords.map((record) => ({
        domainId: record.domainId,
        recordName: record.recordName,
        recordType: record.recordType,
        expectedValue: record.expectedValue,
      })),
    });
    // set configureDate on each dns record that was configured
    queryClient.setQueryData([DOMAIN_DATA, userId], (cache) =>
      cache.map((cachedApexDomain) =>
        cachedApexDomain.domainId === domainId
          ? {
              ...cachedApexDomain,
              dnsRecords: cachedApexDomain.dnsRecords.map((cachedRecord) =>
                configureDNSEvent.jsonData.dnsRecords.some(
                  ({ recordName, recordType, expectedValue }) =>
                    recordName === cachedRecord.recordName &&
                    recordType === cachedRecord.recordType &&
                    expectedValue === cachedRecord.expectedValue
                )
                  ? {
                      ...cachedRecord,
                      configureDate: configureDNSEvent.occurredDate,
                    }
                  : cachedRecord
              ),
            }
          : cachedApexDomain
      )
    );
  } catch (error) {
    // eslint-disable-next-line
    console.error(error);
  }
};

export const mapToEntriRecords = (dnsRecords) =>
  dnsRecords.map(({ recordType, expectedValue, host, ttl }) => ({
    type: recordType,
    value: expectedValue,
    host,
    ttl,
  }));
